import store from "../stores";

const API_ENDPOINT = process.env.REACT_APP_SERVER_URL+"/api";
export const EXTERNAL_API = "http://allrates.jp";

export class EndPoints {

  static areas(){
    return API_ENDPOINT + "/areas";
  }

  static zones(){
    return API_ENDPOINT + "/zones";
  }

  static facility_types(){
    return API_ENDPOINT + "/facility_types";
  }

  static facilities(id=null){
    var base = API_ENDPOINT + "/facilities";
    if(id) {
      base += "/"+id;
    }
    return base;
  }

  static plans(code){
    var url = EXTERNAL_API + "/API/GetData20151112.aspx";
    return url;
  }

}
